import React from 'react';

import {
  ContentSectionContextProps,
  ContentSectionItem,
  GenericConfig,
} from './fragment-and-types';
import { selectComponent } from './helper';

export const ContentSection = React.memo(
  ({
    sections,
    possibleComponents,
    ...context
  }: {
    sections: ContentSectionItem[];
    possibleComponents: GenericConfig[];
  } & Omit<ContentSectionContextProps, 'componentIndex'>) =>
    sections.map((sectionProps, index) =>
      selectComponent(
        sectionProps,
        index,
        {
          ...context,
          componentIndex: index,
        },
        possibleComponents,
      ),
    ),
);
